import * as React from "react";
const SvgChartbarpeak = (props) => /* @__PURE__ */ React.createElement("svg", { "data-testid": "geist-icon", height: 16, strokeLinejoin: "round", viewBox: "0 0 16 16", width: 16, style: {
  color: "currentcolor"
}, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 1V1.75V14.25V15H12.5V14.25V1.75V1H14ZM8.75 6V6.75V14.25V15H7.25V14.25V6.75V6H8.75ZM3.5 10.75V10H2V10.75V14.25V15H3.5V14.25V10.75Z", fill: "currentColor" }));
export default SvgChartbarpeak;
